import { IChatData, IGroupChatData } from "@home-health-notify/domain";
import { Box } from "@mui/material";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { ThumbsUpIcon } from "../message/messageType/AcknowledgeBubble.style";
import theme from "../theme";
import React from "react";
import { ChatListItemTimestamp } from "./ChatList.style";
import { formatChatListDate } from "hhn-commons";
import { Counter } from "../common/Common.style";

export function ChatListItemStatus({ chatData }: { chatData: IChatData }) {
  const hasPriorityMessage = (chatData as IGroupChatData)?.hasPriorityMessage;

  const hasPendingAcknowledgement = (chatData as IGroupChatData)
    ?.hasAcknowledgeMessage;

  return (
    <Box
      sx={{
        flexDirection: "column",
        display: "flex",
        alignItems: "flex-end",
        flex: "1"
      }}>
      <ChatListItemTimestamp
        data-testid="updated-date"
        color={theme.palette.grey[600]}
      >
        {formatChatListDate(chatData.updatedAt)}
      </ChatListItemTimestamp>

      <Box
        sx={{
          display: "flex",
          alignItems: "center"
        }}>
        {hasPriorityMessage && (
          <WarningRoundedIcon
            data-testid="priority-icon"
            color="error"
            style={{ height: "20px", width: "20px" }}
          />
        )}
        {hasPendingAcknowledgement && (
          <ThumbsUpIcon
            data-testid="acknowledgement-icon"
            style={{
              color: `${theme.palette.primary.main}`,
              height: "20px",
              width: "20px",
            }}
          />
        )}
        {chatData.unreadCount ? (
          <Counter
            data-testid="unread-messages-icon"
            backgroundColor={theme.palette.primary.main}
          >
            {chatData.unreadCount}
          </Counter>
        ) : null}
      </Box>
    </Box>
  );
}
